"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APTable = _interopRequireDefault(require("../../common/APTable"));
var _ActivityCellComponents = require("../ActivityCellComponents");
var _get = _interopRequireDefault(require("lodash/get"));
require("./InterestBalances.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('activity', ['interest-balances']);
var InterestBalancesTableComponent = function InterestBalancesTableComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('interest'),
    t = _useTranslation.t;
  var usePagination = props.usePagination,
    selectPositionAndSave = props.selectPositionAndSave,
    rows = props.rows,
    totalValueRow = props.totalValueRow,
    interestPayments = props.interestPayments,
    rates = props.rates;
  return /*#__PURE__*/_react["default"].createElement(_APTable["default"], {
    componentName: 'RecentActivityComponent',
    columns: [{
      header: t('Product'),
      width: '30rem',
      cell: function cell(row, _ref) {
        var rowIndex = _ref.rowIndex;
        if (rowIndex === rows.length) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: baseClass('action')
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: baseClass('action-column')
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: baseClass('action-text', 'primary')
          }, t('Total Value'), ":")));
        }
        return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Action, {
          themeModifier: '',
          onClick: selectPositionAndSave,
          row: row
        });
      }
    }, {
      header: t('Total Balance'),
      width: '20rem',
      cell: function cell(row, _ref2) {
        var rowIndex = _ref2.rowIndex;
        if (rowIndex === rows.length) {
          return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Amount, {
            value: {
              rawAmount: totalValueRow.NotionalValue,
              ProductSymbol: 'USD'
            }
          });
        }
        return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Amount, {
          value: row
        });
      }
    }, {
      header: t('Market Price'),
      width: '20rem',
      cell: function cell(row, _ref3) {
        var rowIndex = _ref3.rowIndex;
        if (rowIndex === rows.length) {
          return /*#__PURE__*/_react["default"].createElement("div", null);
        }
        return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.MarketPrice, row);
      }
    }, {
      header: t('Target Interest Rate'),
      width: '40rem',
      cell: function cell(row, _ref4) {
        var rowIndex = _ref4.rowIndex;
        if (rowIndex === rows.length) {
          return /*#__PURE__*/_react["default"].createElement("div", null);
        }
        return /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            paddingLeft: '2.6rem'
          }
        }, /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Text, {
          text: "".concat((0, _get["default"])(rates, [row.ProductId, 'Rate'], 0), "%")
        }));
      }
    }, {
      header: t('Interest (Total)'),
      width: '15rem',
      cell: function cell(row, _ref5) {
        var rowIndex = _ref5.rowIndex;
        if (rowIndex === rows.length) {
          return /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              paddingLeft: '2.6rem'
            }
          }, /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.InterestAmount, {
            ProductSymbol: "USD",
            Amount: totalValueRow.Total || 0
          }));
        }
        return /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            paddingLeft: '2.6rem'
          }
        }, /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.InterestAmount, {
          ProductSymbol: (0, _get["default"])(row, 'ProductSymbol', ''),
          Amount: (0, _get["default"])(interestPayments, [row.ProductId, 'Total'], '-')
        }));
      }
    }, {
      header: t('Interest (7 Days)'),
      width: '15rem',
      cell: function cell(row, _ref6) {
        var rowIndex = _ref6.rowIndex;
        if (rowIndex === rows.length) {
          return /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              paddingLeft: '2.6rem'
            }
          }, /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.InterestAmount, {
            ProductSymbol: "USD",
            Amount: totalValueRow['7DayEarnings'] || 0
          }));
        }
        return /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            paddingLeft: '2.6rem'
          }
        }, /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.InterestAmount, {
          ProductSymbol: (0, _get["default"])(row, 'ProductSymbol', ''),
          Amount: (0, _get["default"])(interestPayments, [row.ProductId, '7DayEarnings'], '-')
        }));
      }
    }],
    pageSize: 6,
    rows: rows.concat([{}]),
    baseClass: baseClass,
    headerOutside: true,
    usePagination: usePagination,
    empty: t('No data is available')
  });
};
InterestBalancesTableComponent.defaultProps = {
  usePagination: false
};
var _default = exports["default"] = InterestBalancesTableComponent;